export const actionTypes = {
  FETCH_CUSTOMER_SETTLEMENTS: 'FETCH_CUSTOMER_SETTLEMENTS',
  SET_CUSTOMER_SETTLEMENTS: 'SET_CUSTOMER_SETTLEMENTS',
  SET_CUSTOMER_SETTLEMENTS_ERROR: 'SET_CUSTOMER_SETTLEMENTS_ERROR',
  SET_CUSTOMER_SETTLEMENTS_LOADING: 'SET_CUSTOMER_SETTLEMENTS_LOADING',
};

export const fetchCustomerSettlements = () => ({
  type: actionTypes.FETCH_CUSTOMER_SETTLEMENTS,
});

export const setCustomerSettlements = data => ({
  type: actionTypes.SET_CUSTOMER_SETTLEMENTS,
  data,
});

export const setCustomerSettlementsError = error => ({
  type: actionTypes.SET_CUSTOMER_SETTLEMENTS_ERROR,
  error,
});

export const setCustomerSettlementsLoading = loading => ({
  type: actionTypes.SET_CUSTOMER_SETTLEMENTS_LOADING,
  loading,
});
